import { Typography } from "antd";
import {
    convertUnixTimestampToDate,
    jsDateIntoDayjsDate,
} from "Helper/EpochConveter";
import Taglabel from "components/Comman/Taglabel";
import MoreActionDropDown from "components/Comman/MoreActionDropDown";
import MoreActionDropDownData from "./MoreActionDropDownData";
import ShowEntityNo from "components/Comman/ShowEntityNo";


const getColumns = (details) => [
    {
        title: (
            <Taglabel text={"#No"} type={"heading"} details={details} />
        ),
        dataIndex: "no",
        key: "no",
        render: (_, record) => (
            <ShowEntityNo
                prefix={record.prefix}
                no={record.no}
                suffix={record.suffix}
            />
        ),
    },
    {
        title: (
            <Taglabel text={"VENDOR"} type={"heading"} details={details} />
        ),
        dataIndex: "vendor",
        key: "vendor",
        render: (_, record) => (
            <Taglabel
                type="customer"
                text={record?.vendor?.name || ""}
                details={details}
            />
        ),
    },
    {
        title: <Taglabel text={"DATE"} type={"heading"} details={details} />,
        dataIndex: "paymentDate",
        key: "paymentDate",
        render: (_, record) => (
            <Taglabel
                type={"text"}
                text={jsDateIntoDayjsDate(record.paymentDate)}
                details={details}
            />
        ),
    },
    {
        title: <Taglabel text={"AMOUNT"} type={"heading"} details={details} />,
        dataIndex: "amount",
        key: "amount",
        responsive: details ? [] : ["lg"],
        render: (_, record) => (
            <Taglabel
                type="amount"
                text={record?.amount || ""}
                details={details}
            />
        ),
    },
          {
        title: <Taglabel text={"BANK"} type={"heading"} />,
        dataIndex: "invoiceExpiredDate",
        key: "customer",
          responsive: details ? [] : ["lg"],
          render: (_, record) => (
              <Taglabel
                  type="text"
                  text={record.bank ? record.bank : ""}
                  details={details}
              />
          ),
    },
    {
        title: (
            <Taglabel
                text={"PAYMENT MODE"}
                type={"heading"}
                details={details}
            />
        ),
        dataIndex: "paymentMode",
        key: "paymentMode",
        render: (_, record) => (
            <Taglabel
                type="text"
                text={record?.paymentMode || ""}
                details={details}
            />
        ),
    },
    {
        title: <Taglabel text={"NOTE"} type={"heading"} details={details} />,
        dataIndex: "note",
        key: "note",
        render: (_, record) => (
            <Taglabel type="text" text={record?.note || ""} details={details} />
        ),
    },
    {
         dataIndex: "operation",
            fixed: "right",
            render: (_, record) => (
              <MoreActionDropDown
                entity="paymentsmade"
                items={MoreActionDropDownData("paymentsmade")}
                rowData={record}
              />
            ),
          },
];
const paymentData = {
    getColumns,
};

export default paymentData;

export const paymentMode = [
    {
        label: "UPI",
        value: "UPI",
    },
    {
        label: "DEBIT CARD",
        value: "DEBIT CARD",
    },
    {
        label: "CASH",
        value: "CASH",
    },
    {
        label: "CHECK",
        value: "CHECK",
    },
];
